var map = {
	"./sun-glasses-1.jpg": 72,
	"./sun-glasses-2.jpg": 73,
	"./sun-glasses-3.jpg": 74,
	"./sun-glasses-4.jpg": 75,
	"./sun-glasses-5.jpg": 76,
	"./sun-glasses-6.jpg": 77,
	"./sun-glasses-7.jpg": 78,
	"./sun-glasses-8.jpeg": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;